import { CSSProperties } from 'react';
import { COLORS, DISPLAY_STRETCH, FONTS } from '../../../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1.4fr',
    gap: '4.5rem',
    alignItems: 'start',
    marginTop: '3rem',
  },
  intro: {
    fontSize: '1.0625rem',
    lineHeight: 1.7,
    color: COLORS.muted,
  },
  link: {
    color: COLORS.accent,
    textUnderlineOffset: '2px',
  },
  help: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '2rem',
    borderTop: `1px solid ${COLORS.border}`,
  },
  helpItem: {
    padding: '1.1rem 0',
    borderBottom: `1px solid ${COLORS.border}`,
  },
  helpTitle: {
    fontFamily: FONTS.display,
    fontStretch: DISPLAY_STRETCH,
    fontWeight: 600,
    fontSize: '1.2rem',
    color: COLORS.text,
    marginBottom: '0.35rem',
  },
  helpBody: {
    fontSize: '1rem',
    lineHeight: 1.65,
    color: COLORS.muted,
  },
  inApp: {
    fontWeight: 600,
    color: COLORS.text,
  },
};
